import React, { useState } from "react";
import Landing from "./Landing";
import LinksPage from "./LinksPage";
import "./App.css";

function App() {
  const [showLinks, setShowLinks] = useState(false);

  return (
    <div className="App">
      {showLinks ? <LinksPage /> : <Landing onClick={() => setShowLinks(true)} />}
    </div>
  );
}


export default App;
